<template>
  <Swiper
    :slidesPerView="1"
    :spaceBetween="10"
    :centeredSlides="false"
    :preventClicks="true"
    :loop="true"
    :autoplay="{
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    }"
    :speed="18000"
    :direction="horizontal"
    :zoom="true"
    :keyboard="{
      enabled: true,
      onlyInViewport: false,
    }"
    :breakpoints="{
      0: { slidesPerView: 1 },
      340: { slidesPerView: 1 },
      450: { slidesPerView: 1 },
      576: { slidesPerView: 2 },
      768: { slidesPerView: 2 },
      800: { slidesPerView: 2 },
      992: { slidesPerView: 2.5 },
      1440: { slidesPerView: 3 },
      1600: { slidesPerView: 3 },
      1881: { slidesPerView: 4 },
    }"
    :modules="modules"
    class="banner-slide-1"
  >
    <SwiperSlide v-for="(slide, i) in effectiveSlides" :key="i">
      <img :src="slide.image" alt="slide" />
    </SwiperSlide>
  </Swiper>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay } from "swiper/modules";

const defaultImages = [
  require("@/assets/images/slide-1.jpg"),
  require("@/assets/images/slide-2.jpg"),
  require("@/assets/images/slide-3.jpg"),
  require("@/assets/images/slide-4.jpg"),
];

export default defineComponent({
  name: "BannerSlideOne",
  components: { Swiper, SwiperSlide },
  props: {
    customImages: { type: Array as () => Array<{ image_url: string }>, default: () => [] },
  },
  setup(props) {
    const effectiveSlides = computed(() => {
      const cms = props.customImages.filter((i) => i.image_url).map((i) => ({ image: i.image_url }));
      const base = cms.length > 0 ? cms : defaultImages.map((img) => ({ image: img }));
      return [...base, ...base];
    });
    return { effectiveSlides, modules: [Autoplay] };
  },
});
</script>
